import { captureException } from '@sentry/vue';
import forEach from 'lodash/forEach';
import map from 'lodash/map';

export const actions = {
  start ({ rootGetters, dispatch }) {
    const client = rootGetters['feature/client'];

    client.on('update', () => dispatch('updateFeatureFlags'));

    return client.start()
      .then(() => dispatch('updateFeatureFlags'))
      .catch(captureException);
  },

  updateFeatureFlags ({ commit, rootGetters }) {
    const allToggles = rootGetters['feature/client'].getAllToggles();
    const enabledToggleNames = map(allToggles, ({ name }) => name);
    const allFeatureFlagNames = rootGetters['feature/allFeatureFlagNames'] || [];

    // it appears that GitLab does not include disabled feature flags
    // in the API response, so we need to manually add them to the
    // "all toggles" array to ensure that we toggle flag state correctly
    allFeatureFlagNames
      .filter((name) => !enabledToggleNames.includes(name))
      .forEach((name) => {
        allToggles.push({ name, enabled: false });
      });

    forEach(allToggles, ({ name: featureName, enabled }) => {
      commit({ type: 'SET_FEATURE_STATE', featureName, enabled });
    });
  }
};
